exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ndiv[data-v-72ba1a77] {\r\n  font-size: 16px;\n}\n.dataInfo[data-v-72ba1a77] {\r\n  position: fixed;\r\n  left: 0;\r\n  top: 0;\r\n  background: #000;\r\n  color: #fff;\r\n  font-size: 12px;\n}\n.pageBox[data-v-72ba1a77] {\r\n  width: 100vw;\r\n  overflow-x: hidden;\r\n  min-height: 100vh;\n}\r\n", ""]);

// exports
